import BasicSelect from 'further-ui/components/BasicSelect';
import { CalendarDay } from 'further-ui/utils';
import { AccountingPeriodStatus } from 'further-types/lp/accounting-period';
import api from 'lib/trpcClient';
import { useLayoutContext } from 'contexts/LayoutContext';

type Props = {
  selectedDate: CalendarDay | null;
  onChange: (date: CalendarDay) => void;
  minDate?: CalendarDay;
};

const PcapDateSelector: React.FC<Props> = ({
  selectedDate,
  onChange,
  minDate,
}) => {
  const { selectedVehicleId } = useLayoutContext();

  const [periods] = api.accountingPeriod.listPeriods.useSuspenseQuery({
    vehicleId: selectedVehicleId ?? '',
  });

  const availablePeriods = periods.filter(
    (period) => !minDate || period.periodEnd.isSameOrAfter(minDate),
  );

  if (!availablePeriods.length) return null;

  const options = availablePeriods.map((period) => {
    const isClosed = period.status === AccountingPeriodStatus.Approved;
    return {
      value: period.periodEnd.toString(),
      label: `${period.periodEnd.toReadable()}${isClosed ? ' (Closed)' : ''}`,
    };
  });

  return (
    <BasicSelect
      value={selectedDate?.toString() ?? ''}
      onChange={(value) => onChange(new CalendarDay(value))}
      options={options}
      fullWidth
    />
  );
};

export default PcapDateSelector;
